import 'reflect-metadata';
import { container } from 'tsyringe';
import { GetAllConfigs } from './getAllConfigs';
export const DependencyInjectorConfigsInfrastructure = () => {
    container.register("IGetAllConfigs", { useClass: GetAllConfigs });
};
export default DependencyInjectorConfigsInfrastructure;
